import React, { createContext, useContext } from "react";

import RentalInvoicePreview from "./RentalInvoicePreview";

const RentalInvoicePreviewContext = createContext();

export function useRentalInvoicePreviewContext() {
  return useContext(RentalInvoicePreviewContext);
};

const RentalInvoicePreviewProvider = (props) => {
  const {
    rentalInvoice,
    calendarEvent,
  } = props;

  const value = {
    rentalInvoice,
    calendarEvent,
  };

  return (
    <RentalInvoicePreviewContext.Provider value={value}>
      {props.children}
    </RentalInvoicePreviewContext.Provider>
  );
};

const RentalInvoicePreviewContainer = (props) => (
  <RentalInvoicePreviewProvider {...props}>
    <RentalInvoicePreview />
  </RentalInvoicePreviewProvider>
);

export default RentalInvoicePreviewContainer;


